module.exports = __webpack_public_path__ + "img/open_access_prototype.0ef1abcb.jpg";